export enum AvatarType {
    ENTITY = 1,
    ROLE = 2,
    SITE = 3,
    SITE_CHANNEL = 4,
    BOT = 5,
    MAIL = 6,
    HELP_CENTER = 7
}